<template>
  <fieldset id="invoicePayment" class="bs3-margin-top30">
    <legend><i class="fa-light fa-money-check-edit"></i> {{ 'dictionary.invoice.payment' | i18nText(pDictionary) }}</legend>
    <div class="row">
      <div class="col-xs-3">
        <!--
          - PAYMENT DATE
          --->
        <div :class="['form-group', {'has-error': hasFieldErrors('dataForm.data.paymentDateText')}]">
          <div v-if="hasFieldErrors('dataForm.data.paymentDateText')">
            <span v-for="error in getFieldErrors('dataForm.data.paymentDateText')" class="help-block" :key="error">{{
                error
              }}</span>
          </div>
          <label v-else :for="'invoice_DateText'">
            <span v-show="paymentDateRequired" class="required">*</span> {{
              pDictionary['dictionary.invoice.payment.date']
            }}:
          </label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fa-light fa-calendar"></i></span>
            <input ref="paymentDateText"
                   type="text"
                   :id="'invoice_PaymentDateText'"
                   :name="'dataForm.data.paymentDateText'"
                   v-model="invoice.paymentDateText"
                   :placeholder="pDictionary['dictionary.format.date.hint']"
                   class="form-control datepicker paymentDateText"
                   size="10" maxlength="10"
                   autocomplete="off">
          </div>
        </div>
      </div>
      <div class="col-xs-4">
        <!--
          - PAYMENT TYPE
          --->
        <div :class="['form-group', {'has-error': hasFieldErrors('dataForm.data.paymentType')}]">
          <div v-if="hasFieldErrors('dataForm.data.paymentType')">
            <span v-for="error in getFieldErrors('dataForm.data.paymentType')" class="help-block" :key="error">{{ error }}</span>
          </div>
          <label v-else :for="'invoice_PaymentType'">
            <span v-show="paymentTypeRequired" class="required">*</span> {{ pDictionary['dictionary.invoice.payment.type'] }}:
          </label>
          <select ref="paymentTypeSelect"
                  :id="'invoice_PaymentType'"
                  :name="'dataForm.data.paymentType'"
                  v-model="invoice.paymentType"
                  data-container="#bsInvoiceSaveFormDialog"
                  class="form-control selectpicker">
            <option value="">{{ pDictionary['dictionary.invoice.payment.type.select.single'] }}</option>
            <option v-for="paymentType in allPaymentTypes"
                    :value="paymentType"
                    :data-tokens="pDictionary['dictionary.invoice.payment.type.' + paymentType]" :key="paymentType">
              {{ 'dictionary.invoice.payment.type.' + paymentType | i18nText(pDictionary) }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-xs-5">
        <!--
          - PAYMENT REFERENCE
          --->
        <div :class="['form-group', {'has-error': hasFieldErrors('dataForm.data.paymentReference')}]">
          <div v-if="hasFieldErrors('dataForm.data.paymentReference')">
            <span v-for="error in getFieldErrors('dataForm.data.paymentReference')" class="help-block" :key="error">{{ error }}</span>
          </div>
          <label v-else :for="'invoice_PaymentReference'">
            <span v-show="paymentReferenceRequired" class="required">*</span> {{ pDictionary['dictionary.invoice.payment.reference'] }}:
          </label>
          <input type="text"
                 :id="'invoice_PaymentReference'"
                 :name="'dataForm.data.paymentReference'"
                 v-model="invoice.paymentReference"
                 class="form-control "/>
        </div>
      </div>
    </div>
  </fieldset>
</template>

<script>
import BaseMixin from "@/mixins/base-mixin";
import FormMixin from "@/mixins/form-mixin";
import FormatMixin from "@/mixins/format-mixin";
import refHelpers from "@/helpers/ref-helpers";

export default {
  name: "InvoiceSaveFormPaymentSection",
  mixins: [BaseMixin, FormMixin, FormatMixin],
  props: {
    pInvoice: Object
  },
  data: function () {
    return {
      invoice: this.pInvoice,
      allPaymentTypes: ['CASH',
        'CHECK',
        'CREDIT_CARD',
        'BANK_TRANSFER',
        'ONLINE_PAYMENT',
        'MOBILE_PAYMENT',
        'AUTOMATIC_PAYMENT',
        'OTHER']
    }
  },
  computed: {
    workflowStage: function () {
      return refHelpers.getRefParam(this.invoice.statusRef, 'workflowStage', 'EXPECTED');
    },
    paymentDateRequired: function () {
      return this.workflowStage === 'PAID';
    },
    paymentTypeRequired: function () {
      return this.workflowStage === 'PAID';
    },
    paymentReferenceRequired: function () {
      return false;
    }
  },
  mounted: function () {
    let _component = this;

    // Init PaymentDateText.
    let $paymentDateText = $(this.$refs.paymentDateText);
    $paymentDateText.initFromDatePicker(
        {
          dateElId: $paymentDateText.attr('id'),
          linkDateElId: null,
          minDate: null,
          maxDate: null,
          bs3: true,
          f: function (selectedDate) {
            _component.$data.invoice.paymentDateText = selectedDate;
            _component.$refs.paymentDateText.dispatchEvent(new Event('change'));
          }, noWeekends: false
        });

    // Init PaymentTypeSelect
    let $paymentTypeSelect = $(_component.$refs.paymentTypeSelect);
    $paymentTypeSelect.selectpicker();
  },
  updated: function () {
    let _component = this;

    // Update PaymentTypeSelect
    let $paymentTypeSelect = $(_component.$refs.paymentTypeSelect);
    $paymentTypeSelect.selectpicker('refresh');
  },
  destroyed: function () {
    let _component = this;

    // Destroy PaymentTypeSelect
    let $paymentTypeSelect = $(_component.$refs.paymentTypeSelect);
    $paymentTypeSelect.selectpicker('destroy');
  }
}
</script>

<style scoped>

</style>